module.exports = __webpack_public_path__ + "img/BradWarnick.a65d6308.jpg";